import "./DocumentTitle.css";

interface DocumentTitleProps {
  title: string;
}

export const DocumentTitle = ({ title }: DocumentTitleProps) => {
  return <h2 className="about-title">{title}</h2>;
};
